import * as z from "zod";

export const TagSchema = z.object({
  id: z.string().uuid(),
  name: z
    .string()
    .min(1, "Name is required")
    .max(100, "Name must be less than 100 characters")
    .trim(),
  created: z
    .date()
    .optional()
    .default(() => new Date()),
  updated: z
    .date()
    .optional()
    .default(() => new Date()),
});

export const createTagSchema = TagSchema.omit({
  id: true,
  created: true,
  updated: true,
});

export const updateTagSchema = TagSchema.partial().omit({
  id: true,
  created: true,
  updated: true,
});

// Schema for handling multiple tags in products
export const productTagsSchema = z.array(z.string().uuid());
